export const constants = {
    // baseUrl: 'https://oontire-api.onrender.com/api/client/v1',
    baseUrl: 'https://dalabtire.tacabbile.com/api/client/v1',
    baseAdminUrl: 'https://dalabtire.tacabbile.com/api/admin/v1',
    moneySign: "$",
    pColor: "#0047FF",
    sColor: "#E90139", 
    pTextColor: "#CCBED6",
    subColor: "#979797",
    backdropColor: "#F0F5FF",
    activeTabColor: "#F5F5F5",
    sideBarColor: "#FAFAFA",
    colorSubText: "#A5BEFF",
    businnesColor: "#1C49BD",
    businessSubText: "#85A2EB"
}
